import { useEffect, useState } from "react";
import "./UpcomingBirtday.css";
import axios from "axios";
import confetti from "canvas-confetti";

const token = localStorage.getItem("accessToken");

/* 🔹 MANUAL DOB MAP */
const EMPLOYEE_DOB_MAP = {
  "1001": "1994-08-09",
  "1002": "2001-02-23", // Set to today for testing/demonstration if today is 23 Feb
  "1009": "2006-05-23",
  "1019": "2000-12-02",
  "1026": "2001-05-01",
  "1030": "2004-04-12",
  "1031": "2005-07-04",
  "1032": "2004-10-07",
  "1036": "2004-08-10",
  "1039": "2006-09-24",
  "1044": "2006-10-18",
  "1045": "2005-03-22",
  "1048": "2004-07-02",
  "1049": "2000-05-15",
  "1051": "1997-04-09",
  "1052": "2005-02-11",
  "1053": "2002-01-27",
  "1055": "1993-03-12",
  "1057": "2000-02-29",
  "1058": "2002-11-29",
  "1059": "2002-06-03",
  "1060": "2002-08-09",
  "1061": "2003-09-16",
  "1062": "2005-06-24",
  "1063": "2004-02-03",
  "1064": "2002-07-01",
  "1065": "1998-01-22",
  "1066": "2001-10-22",
  "1068": "2002-03-22",
  "1069": "2001-05-21",
};

// This variable persists across component mounts/unmounts until a hard page refresh
let celebrationShown = false;

/* 🔹 BIRTHDAY LOGIC */
const getUpcomingBirthdays = (employees, limit = 2) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return employees
    .filter(
      (emp) =>
        emp.employee_code !== "1000" &&
        EMPLOYEE_DOB_MAP[emp.employee_code]
    )
    .map((emp) => {
      const dob = new Date(EMPLOYEE_DOB_MAP[emp.employee_code]);

      let nextBirthday = new Date(
        today.getFullYear(),
        dob.getMonth(),
        dob.getDate()
      );

      if (nextBirthday < today) {
        nextBirthday.setFullYear(today.getFullYear() + 1);
      }

      const daysLeft = Math.ceil(
        (nextBirthday - today) / (1000 * 60 * 60 * 24)
      );

      return {
        ...emp,
        daysLeft,
        isToday: daysLeft === 0,
      };
    })
    .sort((a, b) => a.daysLeft - b.daysLeft)
    .slice(0, limit);
};

export default function UpcomingBirtday() {
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    const fetchEmployee = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API}/api/account/users-list/?status=true`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setEmployees(res.data || []);
      } catch (err) {
        console.error(err);
      }
    };
    fetchEmployee();
  }, []);

  const upcoming = getUpcomingBirthdays(employees, 2);
  const isAnyBirthdayToday = upcoming.some((e) => e.isToday);

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (isAnyBirthdayToday && !celebrationShown) {
      setShowModal(true);
      celebrationShown = true; // Mark as shown for this session

      const end = Date.now() + 3 * 1000;
      const colors = ["#efbf04", "#ffffff", "#92400e"];

      (function frame() {
        confetti({
          particleCount: 2,
          angle: 270,
          spread: 70,
          origin: { x: Math.random(), y: 0 },
          colors: colors,
          zIndex: 10000,
          gravity: 0.8,
          scalar: 0.7
        });

        if (Date.now() < end) {
          requestAnimationFrame(frame);
        }
      })();

      // Automatically hide the birthday toast after 10 seconds
      const timer = setTimeout(() => {
        setShowModal(false);
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [isAnyBirthdayToday]);

  const birthdayEmp = upcoming.find(e => e.isToday);

  return (
    <div className="UpcomingBirtday">
      <h5 className="UpcomingBirtdayHead">🎂 Upcoming Birthdays</h5>

      {/* 🎊 BIRTHDAY CELEBRATION MODAL */}
      {showModal && birthdayEmp && (
        <div className="birthday-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="birthday-modal-content goldenBirthday" onClick={e => e.stopPropagation()}>
            <button className="birthday-modal-close" onClick={() => setShowModal(false)}>×</button>
            <div className="text-center p-4">
              <div className="modal-cake mb-3">🎂</div>
              <div className="modal-img-wrapper mb-3">
                <img
                  src={birthdayEmp.profile_photo || "/assets/user.png"}
                  alt={birthdayEmp.name}
                  className="modal-emp-img"
                />
              </div>
              <h2 className="modal-birthday-title">
                Today is {birthdayEmp.name}'s Birthday!
              </h2>
              <h3 className="modal-emp-name">Please celebrate</h3>
              <button className="btn btn-warning mt-3 px-4 rounded-pill fw-bold" onClick={() => setShowModal(false)}>
                Celebrate! 🎉
              </button>
            </div>
          </div>
        </div>
      )}

      <ul className="birthdayList">
        {upcoming.length > 0 ? (
          upcoming.map((emp) => (
            <li
              key={emp.id}
              className={`UpcomingBirtdayItem ${emp.isToday ? "goldenBirthday" : ""}`}
            >
              <div className="UpcomingBirtdayContainer">
                <div
                  className="imgbg"
                  style={{
                    backgroundImage: `url(${emp.profile_photo || "/assets/user.png"})`,
                  }}
                />

                <div className="textWrap">
                  <span className="UpcomingBirtdayName">{emp.name}</span>
                  <span className="UpcomingBirtdayDate">
                    {emp.isToday
                      ? "🎉 Birthday Today"
                      : emp.daysLeft === 1
                        ? "⏰ Tomorrow"
                        : `🗓 In ${emp.daysLeft} days`}
                  </span>
                </div>

                {emp.isToday && <span className="cake">🎂</span>}
              </div>
            </li>
          ))
        ) : (
          <p className="text-muted small text-center py-3">No upcoming birthdays</p>
        )}
      </ul>
    </div>
  );
}
